import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { AssetConfig } from "../utils/assets";
import "./Home.css";

const Home = ({ user }) => {
  const [displayedText, setDisplayedText] = useState("");
  const [isTypingComplete, setIsTypingComplete] = useState(false);
  const fullText = "WELCOME TO DIVE-IN PANELS";
  const typingSpeed = 100; // milliseconds per character

  useEffect(() => {
    let currentIndex = 0;

    const typingInterval = setInterval(() => {
      if (currentIndex <= fullText.length) {
        setDisplayedText(fullText.slice(0, currentIndex));
        currentIndex++;
      } else {
        setIsTypingComplete(true);
        clearInterval(typingInterval);
      }
    }, typingSpeed);

    return () => clearInterval(typingInterval);
  }, []);

  return (
    <div className="home">
      {/* Welcome Banner Section - Exact Match */}
      <section className="welcome-banner">
        <div className="container">
          <div className="row align-items-center d-flex">
            <div className="col-lg-6">
              <figure className="welcome-figure">
                <img
                  src={AssetConfig.images.hero}
                  alt="Survey Illustration"
                  className="img-fluid welcome-banner-img"
                />
              </figure>
            </div>
            <div className="col-lg-6">
              <div className="welcome-content">
                <h1 className="welcome-guest-title">
                  <span className="typing-text-guest">{displayedText}</span>
                  {!isTypingComplete && (
                    <span className="typing-dots-guest">..</span>
                  )}
                </h1>
                <h2 className="welcome-main-heading">
                  Your expertise and opinion counts!
                </h2>
                <p className="welcome-description">
                  Dive-In Panels gives you the opportunity to share your ideas
                  and opinions regarding areas of interest. Your views will help
                  decision makers improve their products and services.
                </p>
                <div className="welcome-actions">
                  {user ? (
                    <Link to="/dashboard" className="btn register-now-btn">
                      Go to Dashboard
                    </Link>
                  ) : (
                    <Link to="/auth/register" className="btn register-now-btn">
                      JOIN NOW
                    </Link>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* How It Works Section - Exact Match */}
      <div className="how-it-works">
        <div className="container">
          <h2 className="text-center page-title">
            How Does Dive-inpanels Work?
          </h2>
          <p className="text-center how-text">
            Earn instant cash when you complete a survey
          </p>
          <div className="row panels justify-content-between">
            <div className="col-md-6 col-lg-3 mb-3">
              <div className="inside-box">
                <div className="panel-content">
                  <figure className="panel-icon">
                    <img
                      alt="Register"
                      className="ellipseimg"
                      src={AssetConfig.images.process.step1}
                    />
                  </figure>
                  <p className="mt-4">Register</p>
                  <span>
                    Register on Dive-inpanels. Join a fast-growing community.
                  </span>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-3 mb-3">
              <div className="inside-box">
                <div className="panel-content">
                  <figure className="panel-icon">
                    <img
                      alt="Earn Money Through Surveys"
                      className="ellipseimg"
                      src={AssetConfig.images.process.step2}
                    />
                  </figure>
                  <p className="mt-4">Surveys</p>
                  <span>
                    Receive a survey based on your profile. Follow your
                    interest.
                  </span>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-3 mb-3">
              <div className="inside-box">
                <div className="panel-content">
                  <figure className="panel-icon">
                    <img
                      alt="Get Paid To Take Surveys Online"
                      className="ellipseimg"
                      src={AssetConfig.images.process.step3}
                    />
                  </figure>
                  <p className="mt-4">Paid</p>
                  <span>Get paid to take surveys online—instant payment.</span>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-3 mb-3">
              <div className="inside-box">
                <div className="panel-content">
                  <figure className="panel-icon">
                    <img
                      alt="Rewards"
                      className="ellipseimg"
                      src={AssetConfig.images.features.reward}
                    />
                  </figure>
                  <p className="mt-4">Rewards</p>
                  <span>
                    Refer and earn. Get ample rewards. Offers on your favorite
                    brands.
                  </span>
                </div>
              </div>
            </div>
            <div className="col-md-12">
              {!user ? (
                <Link
                  to="/auth/register"
                  className="btn get-started mx-auto d-block mt-5"
                  tabIndex="0"
                >
                  Join Now
                </Link>
              ) : (
                <Link
                  to="/dashboard"
                  className="btn get-started mx-auto d-block mt-5"
                  tabIndex="0"
                >
                  View Available Surveys
                </Link>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Commitment Section - Exact Match */}
      <div className="how-it-works commited-wrapper">
        <div className="container">
          <h2 className="text-center page-title">
            We stand by our commitments
          </h2>
          <p className="text-center how-text">
            Online surveys, chosen just for you, make earning rewards easy. No
            delays, zero conflicts. Share your voice and start minting bucks.
            <br />
            With assured referral rewards, get your game on with your friends.
            Inspire your acquaintances and earn when they earn.
            <br />
            All this is possible in one place—Dive-inpanels. One of the{" "}
            <Link to="/why-join-us">best online survey sites in India</Link>.
          </p>
          <div className="row progress-row">
            <div className="col-md-12">
              <figure>
                <img
                  alt="Our Commitment"
                  src={AssetConfig.images.features.committed}
                />
              </figure>
            </div>
          </div>
        </div>
      </div>

      {/* Members Paid Section - Exact Match */}
      <div className="members-paid">
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <h3 className="page-title mb-4">
                We've paid our community of varied members over
              </h3>
              <p className="paid-text">
                Teenager or a bloomer; working in a sassy office or a homemaker;
                love taking online surveys for cash or just want to share your
                opinion, Dive-inpanels is the fun place for you.
              </p>
              <p className="paid-text">
                Fill the surveys in your preferred language. Log in to our
                website, get the ball rolling, and bag some quick goodies.
              </p>
            </div>
            <div className="col-md-6 d-flex justify-content-end align-items-center">
              <div className="paid-members-img text-center">
                <img alt="Be a Member" src={AssetConfig.images.group46} />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Customer Reviews Section - Exact Match */}
      {/* <div className="customer-reviews">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <h3 className="page-title text-center">
                What our customer's says
              </h3>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-4">
              <div className="quote">
                <div>
                  <i className="fa fa-quote-left" aria-hidden="true"></i>
                  <p className="review-content">
                    I was flat broke when I lost my job. Grateful to a friend, I
                    started filling surveys. Now I earn a great deal of pocket
                    money by sharing my opinions.
                  </p>
                  <i className="fa fa-quote-right" aria-hidden="true"></i>
                </div>
                <div className="review-user">
                  <figure>T</figure>
                  <h3>Tim</h3>
                  <p>New York</p>
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="quote">
                <div>
                  <i className="fa fa-quote-left" aria-hidden="true"></i>
                  <p className="review-content">
                    I was losing interest when some companies didn't pay me on
                    time, and my rewards slipped into the cracks. But
                    Dive-inpanels brought back the hobby with perks and on-time
                    bucks.
                  </p>
                  <i className="fa fa-quote-right" aria-hidden="true"></i>
                </div>
                <div className="review-user">
                  <figure>L</figure>
                  <h3>Lorraine</h3>
                  <p>Dallas</p>
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="quote">
                <div>
                  <i className="fa fa-quote-left" aria-hidden="true"></i>
                  <p className="review-content">
                    I love earning through online survey sites in India. And
                    Dive-inpanels came as a legit place to do that.
                  </p>
                  <i className="fa fa-quote-right" aria-hidden="true"></i>
                </div>
                <div className="review-user">
                  <figure>R</figure>
                  <h3>Ritesh</h3>
                  <p>Hariyana</p>
                </div>
              </div>
            </div>
          </div>
          <div className="row mt-4">
            <div className="col-lg-4">
              <div className="quote">
                <div>
                  <i className="fa fa-quote-left" aria-hidden="true"></i>
                  <p className="review-content">
                    Online surveys? They are a scam. Dive-inpanels cleared that
                    blind view, and now I often earn extra bucks in four digits
                    every month.
                  </p>
                  <i className="fa fa-quote-right" aria-hidden="true"></i>
                </div>
                <div className="review-user">
                  <figure>S</figure>
                  <h3>Sanchit</h3>
                  <p>Jaipur</p>
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="quote">
                <div>
                  <i className="fa fa-quote-left" aria-hidden="true"></i>
                  <p className="review-content">
                    Their surveys are quick, and I get the money within no time.
                    I feel secured, too, with my sensitive data when using
                    Dive-inpanels.
                  </p>
                  <i className="fa fa-quote-right" aria-hidden="true"></i>
                </div>
                <div className="review-user">
                  <figure>B</figure>
                  <h3>Bishwa</h3>
                  <p>Delhi</p>
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="quote">
                <div>
                  <i className="fa fa-quote-left" aria-hidden="true"></i>
                  <p className="review-content">
                    I used to spend too much time on my phone. I still do. But
                    now I earn by filling free surveys, thanks to Dive-inpanels.
                  </p>
                  <i className="fa fa-quote-right" aria-hidden="true"></i>
                </div>
                <div className="review-user">
                  <figure>A</figure>
                  <h3>Ajay</h3>
                  <p>Noida</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> */}
    </div>
  );
};

export default Home;
